import { useQuery } from "@tanstack/react-query";
import { getTransactionFeesHunterEarnings } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_HUNTER_EARNINGS_QUERY_KEY =
  "TRANSACTIONS_FEES_HUNTER_EARNINGS";

export const getTransactionsFeesHunterEarningsQueryKey = (
  dateFrom?: string | null,
  dateTo?: string | null,
) => [TRANSACTIONS_FEES_HUNTER_EARNINGS_QUERY_KEY, dateFrom, dateTo];

export const useTransactionsFeesHunterEarnings = (
  dateFrom?: string | null,
  dateTo?: string | null,
) =>
  useQuery({
    queryKey: getTransactionsFeesHunterEarningsQueryKey(dateFrom, dateTo),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFeesHunterEarnings(dateFrom, dateTo),
    ),
  });
